import { render, staticRenderFns } from "./EditProductDeptsComponent.vue?vue&type=template&id=47cbfbee&scoped=true"
import script from "./EditProductDeptsComponent.vue?vue&type=script&lang=js"
export * from "./EditProductDeptsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbfbee",
  null
  
)

export default component.exports